// public/js/modules/tenants.js

export async function loadTenants() {
  const res = await window.authenticatedFetch('api/v1/tenants');
  if (!res.ok) throw new Error('Failed to load tenants');
  return (await res.json()).tenants || [];
}

// White-label field config for the caller's own tenants — accessible to ALL
// authenticated members (unlike loadTenants, which needs the listTenants
// permission). Returns [{ tenantId, name, assetFieldLabels, assetFieldVisibility }].
export async function loadTenantFieldConfig() {
  const res = await window.authenticatedFetch('api/v1/tenant-field-config');
  if (!res.ok) throw new Error('Failed to load tenant field config');
  return (await res.json()).tenants || [];
}

export async function createTenant(tenantData) {
  const res = await window.authenticatedFetch('api/v1/tenants', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(tenantData),
  });
  if (!res.ok) throw new Error('Failed to create tenant');
  return res.json();
}

export async function updateTenant(tenantId, updates) {
  const res = await window.authenticatedFetch(`api/v1/tenants/${encodeURIComponent(tenantId)}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(updates),
  });
  if (!res.ok) throw new Error('Failed to update tenant');
  return res.json();
}

// suppressNotify: skip the per-call access email (the UI batches changes and
// sends ONE consolidated email afterwards via notifyAccessChange).
export async function assignUserToTenant(userId, tenantId, { suppressNotify = false } = {}) {
  const res = await window.authenticatedFetch(`api/v1/users/${encodeURIComponent(userId)}/tenants`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ tenantId, suppressNotify }),
  });
  if (!res.ok) throw new Error('Failed to assign user to tenant');
  return res.json();
}

export async function unassignUserFromTenant(userId, tenantId, { suppressNotify = false } = {}) {
  const q = suppressNotify ? '?suppressNotify=1' : '';
  const res = await window.authenticatedFetch(
    `api/v1/users/${encodeURIComponent(userId)}/tenants/${encodeURIComponent(tenantId)}${q}`,
    { method: 'DELETE' }
  );
  if (!res.ok) throw new Error('Failed to remove user from tenant');
  return res.json().catch(() => ({}));
}

export async function getUserTenants(userId) {
  return [];
}